module.exports = __webpack_public_path__ + "static/media/rawpixel-1090772-unsplash.c4ccbfc8.jpg";